<template>
  <div class="mydepartment bg-white report pb-12">
    <div class="text-white font-bold p-0 bg-primary-default">
      <div class="ml-auto w-11/12">
        <div class="grid grid-rows md:grid-cols md:grid-cols-3">
          <div class="py-4">
            <!-- Back Link -->
            <div class="text-sm mb-1 cursor-pointer -ml-1">
              <router-link to="/">
                <ChevronLeftIcon class="h-5 w-5 inline-block align-text-top" aria-hidden="true" />
                <span class="align-middle">Patiënt zoeken</span>
              </router-link>
            </div>
            <h1 class="text-2xl font-bold tracking-tight text-white m-0 pl-1">Mijn afdeling</h1>
          </div>
          <div class="justify-items-end place-content-center space-x-2 mr-9 md:mr-12 col-span-2">
            <div
              class="flex justify-end place-content-end items-start md:items-end self-start flex-wrap flex-row mb-4 lg:mb-0 gap-y-2"
            >
              <button
                @click="$router.push('/collega-registreren')"
                class="flex justify-center py-2 px-2 md:px-4 border border-white shadow-sm text-sm font-medium text-white rounded-full bg-transpartent hover:bg-primary-default/50 items-center mr-0 md:mr-4"
              >
                <PlusCircleIcon class="h-5 w-5 flex-shrink-0 text-white" />
                <span class="ml-1">Collega toevoegen</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="pt-6 mx-auto w-10/12 min-h-screen text-pdsPrimaryColor">
      <div class="shadow bg-white rounded border broder-bdefault" v-if="myDepartmentTexts">
        <h1 class="py-4 px-6 font-bold text-xl flex text-talternative-color bg-balternative-color my-0">Gegevens</h1>
        <legend class="mx-4 mt-4">
          Instelling: <span>{{ myDepartmentTexts.institutionName }}</span>
        </legend>
        <legend class="mx-4 mt-4">
          Afdeling: <span>&nbsp;&nbsp;{{ myDepartmentTexts.departmentName }}</span>
        </legend>
        <tables class="m-4">
          <template #tableHeaders>
            <thead>
              <tr class="bg-sky-50">
                <th
                  scope="col"
                  class="py-3.5 pl-4 pr-3 text-left text-base font-bold text-pdsPrimaryColor text-balance max-w-48 xl:max-w-full min-w-32"
                  v-for="header in tableHeaders"
                  :key="header"
                >
                  {{ header }}
                </th>
              </tr>
            </thead>
          </template>
          <template #tableBody>
            <tbody class="bg-white divide-y divide-sky-200">
              <tr v-for="(colleague, index) in departmentColleagues" :key="index">
                <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-pdsPrimaryColor w-3">
                  {{ colleague.name }}
                </td>
                <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-pdsPrimaryColor w-3">
                  {{ colleague.externalId }}
                </td>
                <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-pdsPrimaryColor w-3">
                  {{ colleague.email }}
                </td>
                <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-pdsPrimaryColor w-3">
                  <span v-show="colleague.isPrescriber">
                    <CheckCircleIcon class="h-6 w-6 flex-shrink-0 text-pdsPrimaryColor" aria-hidden="true" />
                  </span>
                  <span v-show="!colleague.isPrescriber">
                    <XCircleIcon class="h-6 w-6 flex-shrink-0 text-gray-300" aria-hidden="true" />
                  </span>
                </td>
                <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-pdsPrimaryColor w-3">
                  <!-- <span v-if="colleague.warranters">{{ colleague.warranters.join(', ') }}</span> -->
                  <div v-for="(warranter, warranterIndex) in colleague.warranters" :key="warranterIndex">
                    {{ warranter }}
                  </div>
                </td>
                <td
                  v-if="colleague.isProxy"
                  class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-pdsPrimaryColor w-3 relative"
                  id="warranters-root"
                >
                  <button
                    @click.stop="toggleDropdown(index)"
                    class="rounded-full p-1 text-gray-400 hover:text-gray-600 float-end"
                  >
                    <EllipsisVerticalIcon
                      class="h-5 w-5 flex-shrink-0 text-pdsPrimaryColor cursor-pointer"
                      aria-hidden="true"
                    />
                  </button>
                  <div
                    v-if="openDropdownIndex === index"
                    class="absolute top-8 right-5 z-10 mt-2 w-fit rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                  >
                    <a
                      @click.stop.prevent="addWarranterDialog(colleague)"
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer flex"
                    >
                      <UserGroupIcon class="h-5 w-5 flex-shrink-0 tetext-pdsPrimaryColor mr-2" aria-hidden="true" />
                      Volmachtgever(s) toevoegen
                    </a>
                  </div>
                </td>
                <td v-else></td>
              </tr>
            </tbody>
          </template>
        </tables>
      </div>
      <modal-dialog :modal-open-status="showAddWarranterDialog" :showCloseButton="true" @close="closeDropdown()">
        <template #header>
          <div class="text-black">
            <h1 class="text-2xl font-bold mb-2 text-pdsPrimaryColor">Volmachtgever(s) toevoegen</h1>
          </div>
        </template>
        <template #body>
          <div class="flex flex-row mt-4 max-h-96 overflow-y-auto">
            <div class="grid gap-2 my-2">
              <div
                class="relative flex items-start min-h-8"
                v-for="(warranter, index) in warrantersDetails"
                :key="index"
              >
                <div class="flex px-2 items-center">
                  <input
                    :id="warranter.externalId"
                    :aria-describedby="warranter.externalId"
                    name="prescriberWarranter"
                    type="checkbox"
                    v-model="warranter.active"
                    class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                  />
                  <label
                    :for="warranter.externalId"
                    class="ml-3 block text-sm font-medium leading-6 text-black content-center"
                  >
                    {{ warranter.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <div class="flex w-full items-center justify-between gap-4">
            <a
              class="text-pdsPrimaryColor font-bold mt-2 cursor-pointer text-xs md:text-base mr-2"
              @click.prevent="closeDropdown()"
            >
              Annuleren
            </a>
            <button
              @click.prevent="updateWarranterDetails()"
              class="flex justify-center py-2 px-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full ml-auto text-nowrap"
            >
              <span class="md:ml-1"> Volmachtgever(s) toevoegen </span>
            </button>
          </div>
        </template>
      </modal-dialog>
      <form @submit.prevent="submitComments">
        <div class="shadow bg-white rounded border broder-bdefault mt-4" v-if="myDepartmentTexts">
          <h1 class="py-4 px-6 font-bold text-xl flex text-talternative-color bg-balternative-color my-0">
            Kloppen uw gegevens nog?
          </h1>
          <legend class="mx-4 mt-4">
            Wij horen het graag wanneer hier onjuiste gegevens staan. Na ontvangst van uw feedback zullen wij deze
            z.s.m. controleren en verwerken.
          </legend>
          <div class="mx-4 mb-8">
            <v-textarea-group v-model="comments" label="Uw bericht:" inputid="comments" @input="saveComments" />
            <div v-show="showErrorMessage" class="form-group-simple__details errorMessage">
              <div class="form-group-simple__messages">
                <div class="form-group-simple__error">* Dit veld is verplicht.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex col-2 py-4 justify-end gap-2">
          <button
            type="submit"
            class="text-white text-center rounded-full border w-32 h-10 cursor-pointer bg-pdsPrimaryColor border-pdsPrimaryColor"
          >
            VERSTUREN
          </button>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import { useStore, mapActions } from 'vuex';
import {
  departmentColleagues$,
  myDepartmentTexts$,
  currentUserIdentity$,
  addDepartmentColleagues,
  deleteDepartmentColleagues,
  refreshDepartmentColleagues
} from '@/services';
import router from '@/router';
import { ref, getCurrentInstance, onMounted, onUnmounted } from 'vue';
import {
  PlusCircleIcon,
  ChevronLeftIcon,
  CheckCircleIcon,
  XCircleIcon,
  EllipsisVerticalIcon,
  UserGroupIcon
} from '@heroicons/vue/20/solid';
export default {
  name: 'Mydepartment',
  components: {
    PlusCircleIcon,
    ChevronLeftIcon,
    CheckCircleIcon,
    XCircleIcon,
    EllipsisVerticalIcon,
    UserGroupIcon
  },
  emits: ['success'],
  setup(props, { emit }) {
    const store = useStore();
    const submitFeedback = (value) => store.dispatch('patient/submitFeedback', value);
    const $emitter = getCurrentInstance().appContext.config.globalProperties.$emitter;
    const departmentColleagues = ref(null);
    const myDepartmentTexts = ref(null);
    const comments = ref('');
    const showErrorMessage = ref(false);
    const showAddWarranterDialog = ref(false);
    const selectedColleague = ref(null);
    const openDropdownIndex = ref(null);
    const user = ref(null);
    const warrantersDetails = ref(null);
    departmentColleagues$.subscribe((value) => (departmentColleagues.value = value));
    myDepartmentTexts$.subscribe((value) => (myDepartmentTexts.value = value));
    currentUserIdentity$.subscribe((identity) => {
      user.value = identity;
    });
    const tableHeaders = ['Naam', 'Mediq referentie', 'E-mail', 'Voorschrijver', 'Onder volmacht van', ''];

    const saveComments = (event) => {
      comments.value = event.target ? event.target.value : '';
      showErrorMessage.value = comments.value !== '' ? false : true;
    };

    const submitComments = () => {
      if (comments.value !== '') {
        submitFeedback({ Comments: comments.value }).then((response) => {
          if (response === true) {
            emit('success');
            $emitter.emit('alert', { message: 'Bedankt, uw suggestie is met succes verstuurd!' });
          } else {
            $emitter.emit('alert', {
              message: 'Oops het versturen ging niet helemaal goed. Laten we dit als eerste maar eens verbeteren.'
            });
          }
          setTimeout(() => {
            router.push('/');
          }, 2000);
        });
      } else {
        showErrorMessage.value = true;
      }
    };

    const addWarranterDialog = (colleague) => {
      selectedColleague.value = colleague;
      showAddWarranterDialog.value = true;
      warrantersDetails.value = departmentColleagues.value
        .filter(
          (departmentColleague) =>
            departmentColleague.isPrescriber &&
            departmentColleague.externalId !== user.value.externalId &&
            colleague.userId !== departmentColleague.userId
        )
        .map((departmentColleague) => ({
          ...departmentColleague,
          active: colleague.warranters?.includes(departmentColleague.name) ?? false
        }));
    };

    const updateWarranterDetails = async () => {
      const nonMatchingWarranters = warrantersDetails.value
        .filter((warranter) => !selectedColleague.value.warranters?.includes(warranter.name) && warranter.active)
        .map((warranter) => ({
          userId: warranter.userId,
          ppwRecId: selectedColleague.value.ppwRecId
        }));

      const removedWarranters = warrantersDetails.value
        .filter((warranter) => selectedColleague.value.warranters?.includes(warranter.name) && !warranter.active)
        .map((warranter) => ({
          userId: warranter.userId,
          ppwRecId: selectedColleague.value.ppwRecId
        }));

      const requests = [];

      if (nonMatchingWarranters.length) {
        requests.push(
          addDepartmentColleagues({
            DepartmentColleague: nonMatchingWarranters
          })
        );
      }

      if (removedWarranters.length) {
        requests.push(
          deleteDepartmentColleagues({
            DeleteDepartmentColleague: removedWarranters
          })
        );
      }

      if (!requests.length) {
        closeDropdown();
        return;
      }

      const responses = await Promise.all(requests);

      if (responses.every(Boolean)) {
        closeDropdown();
        refreshDepartmentColleagues();
      }
    };

    const toggleDropdown = (i) => {
      openDropdownIndex.value = openDropdownIndex.value === i ? null : i;
    };

    const closeDropdown = () => {
      showAddWarranterDialog.value = false;
      openDropdownIndex.value = null;
      warrantersDetails.value = null;
      selectedColleague.value = null;
      openDropdownIndex.value = null;
    };

    const handleClickOutside = (event) => {
      const el = document.getElementById('warranters-root');
      if (el && !el.contains(event.target)) {
        closeDropdown();
      }
    };

    onMounted(() => {
      document.addEventListener('click', handleClickOutside);
    });

    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
    });

    return {
      ...mapActions('patient', ['submitFeedback']),
      submitFeedback,
      departmentColleagues,
      myDepartmentTexts,
      comments,
      showErrorMessage,
      tableHeaders,
      saveComments,
      submitComments,
      showAddWarranterDialog,
      updateWarranterDetails,
      selectedColleague,
      openDropdownIndex,
      toggleDropdown,
      closeDropdown,
      warrantersDetails,
      addWarranterDialog,
      handleClickOutside
    };
  }
};
</script>
